export const MANAGE_PAYMENT_PROCESSING = {
    DELETE_DIALOG: "payment-processing-delete-dialog",
    DELETE_DIALOG_CONFIRM: "payment-processing-delete-dialog-confirm",
    DELETE_DIALOG_CANCEL: "payment-processing-delete-dialog-cancel",
};
